export default __webpack_public_path__ + "static/media/Monk's Tunic of the Black Thread.560fa50f.jpg";